import { initGroupCadenceApp } from 'ee/iterations';

initGroupCadenceApp();
